import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

export function resolveUpdateCartCommentUrl(activeCartId: string): string {
  return occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/affiliate-comment`);
}

export async function apiUpdateCartComment(comment: string) {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot update Cart comment without an explicit Active Cart identity");
  }
  return occFetch(resolveUpdateCartCommentUrl(activeCartId), {
    method: "PUT",
    body: JSON.stringify({ comment }),
    headers: {
      "content-type": "application/json",
    },
  });
}
